export default () => ({
  yAxis: {
    labels: {
      style: {
        visibility: 'hidden',
      },
    },
  },
});
